'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleWrapper = exports.ToggleSlider = exports.ToggleRail = exports.ToggleRailWrapper = exports.ToggleLabel = exports.ToggleInput = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  cursor: inherit;\n  height: 100%;\n  left: 0px;\n  margin: 0px;\n  opacity: 0;\n  padding: 0px;\n  pointer-events: all;\n  position: absolute;\n  width: 100%;\n  z-index: 2;\n'], ['\n  box-sizing: border-box;\n  cursor: inherit;\n  height: 100%;\n  left: 0px;\n  margin: 0px;\n  opacity: 0;\n  padding: 0px;\n  pointer-events: all;\n  position: absolute;\n  width: 100%;\n  z-index: 2;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  display: block;\n  font-family: ', ';\n  font-size: ', 'px;\n  line-height: ', ';\n  margin-', ': 10px;\n  position: relative;\n  transition: color .3s;\n  white-space: ', ';\n'], ['\n  color: ', ';\n  display: block;\n  font-family: ', ';\n  font-size: ', 'px;\n  line-height: ', ';\n  margin-', ': 10px;\n  position: relative;\n  transition: color .3s;\n  white-space: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  height: 20px;\n  position: relative;\n  width: ', ';\n  z-index: 0;\n'], ['\n  height: 20px;\n  position: relative;\n  width: ', ';\n  z-index: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  border-radius: 30px;\n  height: 14px;\n  left: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  overflow: hidden;\n  position: absolute;\n  top: 3px;\n  width: 100%;\n  z-index: 1;\n\n  &::before,\n  &::after {\n    background-color: ', ';\n    content: \'\';\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0.5;\n    position: absolute;\n    top: 0;\n    transition: background-color .3s;\n    width: 100%;\n    z-index: 0;\n  }\n\n  &::before {\n    ', '\n  }\n\n  &::after {\n    background-color: ', ';\n    opacity: 0;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition-duration: ', 'ms;\n    transition-property: opacity, transform;\n    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n    z-index: 1;\n\n    ', '\n\n    ', '\n  }\n'], ['\n  border-radius: 30px;\n  height: 14px;\n  left: 0;\n  margin-top: auto;\n  margin-bottom: auto;\n  overflow: hidden;\n  position: absolute;\n  top: 3px;\n  width: 100%;\n  z-index: 1;\n\n  &::before,\n  &::after {\n    background-color: ', ';\n    content: \'\';\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0.5;\n    position: absolute;\n    top: 0;\n    transition: background-color .3s;\n    width: 100%;\n    z-index: 0;\n  }\n\n  &::before {\n    ', '\n  }\n\n  &::after {\n    background-color: ', ';\n    opacity: 0;\n    transform: scaleX(0);\n    transform-origin: left;\n    transition-duration: ', 'ms;\n    transition-property: opacity, transform;\n    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n    z-index: 1;\n\n    ', '\n\n    ', '\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  background-color: ', ';\n  border-radius: 50%;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  color: rgba(0, 0, 0, 0.87);\n  height: 20px;\n  left: 0;\n  line-height: 24px;\n  position: absolute;\n  top: 0;\n  transform: translateX(0);\n  transition-duration: ', 'ms;\n  transition-property: transform, background-color;\n  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n  width: 20px;\n  z-index: 5;\n\n  ', '\n\n  ', '\n'], ['\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  background-color: ', ';\n  border-radius: 50%;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;\n  color: rgba(0, 0, 0, 0.87);\n  height: 20px;\n  left: 0;\n  line-height: 24px;\n  position: absolute;\n  top: 0;\n  transform: translateX(0);\n  transition-duration: ', 'ms;\n  transition-property: transform, background-color;\n  transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n  width: 20px;\n  z-index: 5;\n\n  ', '\n\n  ', '\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  align-items: center;\n  cursor: ', ';\n  display: flex;\n  height: auto;\n  min-height: 24px;\n  overflow: visible;\n  position: relative;\n  width: auto;\n'], ['\n  align-items: center;\n  cursor: ', ';\n  display: flex;\n  height: auto;\n  min-height: 24px;\n  overflow: visible;\n  position: relative;\n  width: auto;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getLabelColor = function getLabelColor(props) {
  if (props.disabled) {
    return props.theme.color.base3;
  }

  if (props.toggled) {
    if (props.labelVariant) {
      return props.theme.color[props.labelVariant];
    }

    return props.theme.color[props.variant];
  }
  return props.variant === 'white' ? props.theme.color.white : props.theme.color.base3;
};

var ToggleInput = exports.ToggleInput = _styledComponents2.default.input(_templateObject);

ToggleInput.displayName = 'ToggleInput';
var ToggleLabel = exports.ToggleLabel = _styledComponents2.default.label(_templateObject2, function (props) {
  return getLabelColor(props);
}, function (props) {
  return props.theme.font.bold;
}, function (props) {
  return props.theme.size[4];
}, function (props) {
  return props.size;
}, function (props) {
  return props.labelPosition === 'left' ? 'right' : 'left';
}, function (props) {
  return props.wrapText ? 'normal' : 'nowrap';
});

ToggleLabel.displayName = 'ToggleLabel';
var ToggleRailWrapper = exports.ToggleRailWrapper = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.railWidth;
});

ToggleRailWrapper.displayName = 'ToggleRailWrapper';
var ToggleRail = exports.ToggleRail = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.theme.color.base3;
}, function (props) {
  return props.disabled && '\n      background-color: ' + props.theme.color.base3 + ';\n    ';
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.toggled && '\n      opacity: 0.6;\n      transform: scaleX(1);\n      transition-duration: .2s, ' + props.transitionDuration + 'ms;\n    ';
}, function (props) {
  return props.disabled && '\n      transform: scaleX(0);\n    ';
});

ToggleRail.displayName = 'ToggleRail';
var ToggleSlider = exports.ToggleSlider = _styledComponents2.default.div(_templateObject5, function (props) {
  return (0, _helpers.darkenColor)(props.theme.color.base3, 5);
}, function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.disabled && '\n    background-color: ' + (0, _helpers.lightenColor)(props.theme.color.base3, 5) + ';\n  ';
}, function (props) {
  return props.toggled && '\n    background-color: ' + props.theme.color[props.variant] + ';\n    transform: translateX(-20px) translateX(' + props.railWidth + ');\n  ';
});

ToggleSlider.displayName = 'ToggleSlider';
var ToggleWrapper = exports.ToggleWrapper = _styledComponents2.default.div(_templateObject6, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});
ToggleWrapper.displayName = 'ToggleWrapper';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-toggle/styles.js
// module id = 3049
// module chunks = 4